module.exports = __webpack_public_path__ + "img/Frame_45.557b5979.png";